import { useState } from 'react';
import BacktestControlPanel from '../components/BacktestControlPanel';
import BacktestContractChart from '../components/BacktestContractChart';
import BacktestTable from '../components/BacktestTable';
import Last30ContractChart from '../components/Last30ContractChart';
import Last30Widget from '../components/Last30Widget';
import Last30HistoryWidget from '../components/Last30HistoryWidget';
import BuyDipContractChart from '../components/BuyDipContractChart';
import BuyDipWidget from '../components/BuyDipWidget';
import StrategyVersionTracker from '../components/StrategyVersionTracker';
import SpyEmaStrategyVersionTracker from '../components/SpyEmaStrategyVersionTracker';
import SpyLongShortStrategyVersionTracker from '../components/SpyLongShortStrategyVersionTracker';
import SPX20PointStrangleTable from '../components/SPX20PointStrangleTable';
import SPX5PointStrangleTable from '../components/SPX5PointStrangleTable';

// Interactive backtest for the cheap-bot ignition trigger (backend:
// handlers/cheap_backtest_run.go + cmd/cheapbacktest, both built on
// backend/backtest). Control panel (date-range picker, on-demand data cache
// via "Load Data", live-editable strategy params, stoppable "Start"/"Stop"
// run) above the results table. Admin-only.
//
// SPY panel/table DISABLED 2026-07-11 (SPX-only focus per user). The
// backend still supports variant=spy and the cached SPY data is untouched -
// restore the commented block below to bring it back.
export default function BotTest() {
  const [spxRefresh, setSpxRefresh] = useState(0);
  // Chart of whichever row was last clicked in the SPX results table,
  // reading straight from the cached bars (see BacktestContractChart).
  const [selectedSpxContract, setSelectedSpxContract] = useState(null);
  // Selected trade in the live Last-30-Min widget (chart above it).
  const [selectedLast30, setSelectedLast30] = useState(null);
  // Selected trade in the History widget - reuses BacktestContractChart
  // since both read straight from the same cheap_backtest_data cache.
  const [selectedLast30Hist, setSelectedLast30Hist] = useState(null);
  // Selected trade in the live Buy-the-Dip recorder (chart above it).
  const [selectedBuyDip, setSelectedBuyDip] = useState(null);

  return (
    <div>
      {/*
      <BacktestControlPanel variant="spy" onResultsUpdated={() => setSpyRefresh((n) => n + 1)} />
      <BacktestTable
        variant="spy"
        title="Backtest (SPY)"
        subtitle="Pick a test period above, Load Data to cache it (only fetched from Alpaca once), then Start to run the ignition trigger against it with the parameters shown. Bars carry no bid/ask, so entries are simulated at last-trade (slightly optimistic vs paying the ask)."
        refreshSignal={spyRefresh}
      />
      */}
      <BacktestControlPanel variant="spx" onResultsUpdated={() => setSpxRefresh((n) => n + 1)} />
      <BacktestContractChart variant="spx" contract={selectedSpxContract} />
      <BacktestTable
        variant="spx"
        title="Backtest (SPX)"
        subtitle="Pick a test period above, Load Data to cache it (only fetched from Alpaca once), then Start to run the ignition trigger against it with the parameters shown. Bars carry no bid/ask, so entries are simulated at last-trade (slightly optimistic vs paying the ask). Click a row to chart that contract."
        refreshSignal={spxRefresh}
        onSelect={setSelectedSpxContract}
      />
      {/* Live last-30-minutes engine (handlers/last30_bot.go): runs every
          session 15:30-16:00 ET with simulated fills at real quotes,
          records to last30_trades. Chart above, review table below. */}
      <Last30ContractChart contract={selectedLast30} />
      <Last30Widget onSelect={setSelectedLast30} />
      {/* Historical replay of the same rule set against cached SPX bars
          (handlers/last30_history.go) - read-only, never touches Alpaca or
          the live table. Reuses BacktestContractChart since it already
          reads straight from cheap_backtest_data with no live calls. */}
      <BacktestContractChart variant="spx" contract={selectedLast30Hist} />
      <Last30HistoryWidget onSelect={setSelectedLast30Hist} />
      {/* Live all-day buy-the-dip recorder (handlers/buydip_bot.go), the
          productized doubler-study strategy. Chart above, review table below. */}
      <BuyDipContractChart contract={selectedBuyDip} />
      <BuyDipWidget onSelect={setSelectedBuyDip} />
      {/* Manually-maintained record of the SPY RSI Strategy's rule changes
          across backtest rounds (backend/cmd/spyrsibacktest) - static, no
          API call. */}
      <StrategyVersionTracker />
      <SpyEmaStrategyVersionTracker />
      <SpyLongShortStrategyVersionTracker />
      <SPX20PointStrangleTable />
      <SPX5PointStrangleTable />
    </div>
  );
}
